import HostedMobileLayout from '../../../layouts/MobileLayout';
import HostedAbortScreen from '../shared/AbortScreen';
import { type AbortPageProps } from '../../../chulak/ChulakSession';

export default function HostedMobileAbortPage(props: AbortPageProps) {
  return (
    <HostedMobileLayout>
      <HostedAbortScreen {...props} buttonDirection="col" />
    </HostedMobileLayout>
  );
}
